import { MessageV2DTO } from 'support/types';
import portalSchema from 'support/types/schema-portal';

type Annotation = portalSchema.components['schemas']['Annotation'];

export const getUnmatchedArticleLineItemIndex = (path: string): number | null => {
  const match = path.replace(/^\$\.?/, '').match(/line_items\.(\d+)/);
  return match ? Number(match[1]) : null;
};

export const findUnmatchedArticleAnnotations = (message: MessageV2DTO): Array<Annotation> => {
  const annotations = message.annotations ?? [];
  return annotations.filter(
    (annotation) =>
      annotation.type === 'WARNING' && annotation.value.code === 'UNMATCHED_ARTICLE' && annotation.resolved_at === null,
  );
};
